export interface JsonContractCgvStatus {
  id: string;
  name: string;
  numOrdre: number;
}

export class ContractCgvStatus {
  id: string;
  name: string;
  numOrdre: number;

  constructor(jsonContractCgvStatus: JsonContractCgvStatus = null) {
    if (jsonContractCgvStatus) {
      this.id = jsonContractCgvStatus.id;
      this.name = jsonContractCgvStatus.name;
      this.numOrdre = jsonContractCgvStatus.numOrdre;
    }
  }
}
